/* eslint-disable no-dupe-keys */
export default {
  idle_fee_bill: {
    name: '占位费账单',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '占位费账单号',
      charge_station: '充电站',
      ev_charging_station: '充电站',
      charger: '充电桩',
      user: '用户',
      order: '订单',
      order_trade_number: '充电订单号',
      charge_record_evcs_seq: '互联互通单号',
      idle_fee_during_time: '占位时间',
      idle_fee_begin_at: '占位开始时间',
      idle_fee_finished_at: '占位结束时间',
      free_minutes: '免费时长',
      idle_seconds: '占位时长',
      idle_fee_amount: '占位费',
      idle_fee_price: '占位费价格',
      idle_fee_rule: '收费规则',
      idle_fee_rule: '收费规则',
      discount_amount: '优惠金额',
      amount: '实付金额',
      actual_payment_amount: '应付金额',
      status: '支付状态',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      consumed_power: '充电电量',
      has_settled: '是否已结算',
      charging_finished_at: '充电结束时间',
      charging_periods: '收费时间段',
      idle_fee_bill_source_type: '账单来源',
      paid_at: '支付时间'
    },
    // Enum的属性
    statuses: {
      unpaid: '未支付',
      paid: '已支付'
    },
    // Boolean的属性
    has_settleds: {
      true: '已结算',
      false: '未结算'
    },
    idle_fee_bill_source_types: {
      ecmp: 'ECMP',
      evcs: '互联互通'
    },
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      order_info: '充电订单信息',
      payment_info: '支付信息',
      charger_status: '电桩状态'
    },
    labels: {
      amount: '实付总额',
      discount_amount: '优惠总额',
      idle_fee_amount: '占位费总额',
      idle_fee_unpaid_amount: '未支付总额'
    },
    order: {
      charging_started_at: '充电启动时间',
      charging_finished_at: '充电结束时间',
      consumed_power: '电量',
      amount: '实付金额',
      payable_amount: '应付金额',
      stop_reason: '停止原因'
    },
    tips: {
      confirm_cancel_bill: '确认撤销当前占位费账单？',
      success_cancel_bill: '成功撤销 {0} 占位费账单'
    },
    list_tabs: {
      all: '全部',
      unpaid: '未支付'
    }
  }
}
